import FloatingBox from './floating-box'

export default FloatingBox
